export const AmountField = (value) => {
    if (value == '') {
        return {
            status: false,
            msg: 'Completează câmpul'
        }
    } else if (isNaN(value)) {
        return {
            status: false,
            msg: 'Completează doar cifre'
        } 
    } else if (value<= 0) {
        return {
            status: false,
            msg: 'Completeaza o sumă pozitivă'
        }
    } else {
        return {
            status: true,
            msg: ''
        }
    }
}

export const CurrencyField = (value) => {
    if (value == '') {
        return {
            status: false,
            msg: 'Selectează o monedă'
        }
    } else if (value !='RON' && value!='EUR' && value!='USD' && value!='CHF') {
        return {
            status: false,
            msg: 'Monedă incorectă'
        } 
    } else {
        return {
            status: true,
            msg: ''
        }
    }
}

export const SelectionField= (value, param=null) => {
    
    if (value=='') {
        return {
            status: false,
            msg: 'Alege o opțiune'
        }
    } 

    if (param) {
        const {options, labelKey} = param;
        if (options && options.length && labelKey) {
            if (labelKey) {
                if ( !options.find( item => item[labelKey] == value) ) {
                    return {
                        status: false,
                        msg: 'Alege o opțiune din listă',
                    }
                }
            } else {
                if (!options.includes(value)) {
                    return {
                        status: false,
                        msg: 'Alege o opțiune din listă',
                    }
                }
            }
            
        }
    }

    

    return {
        status: true,
        msg: ''
    }
    

}

export const RadioField= (value, param) => {
  
    const {field} = param;
    let radioBtn = document.querySelectorAll("input[name='"+field+"']");

    let status = false;
    for (let i=0; i<radioBtn.length; i++) {
        if (radioBtn[i].checked) {
            status = true;
        }
    }

    if (!status) {
        return {
            status: false,
            msg: 'Alege o opțiune'
        }
    } else {
        return {
            status: true,
            msg: ''
        }
    }

}

export const TermDeposit = (value) => {
    if (value == '') {
        return {
            status: false,
            msg: 'Completează câmpul'
        }
    } else if ( value=='other') {
        return {
            status: true,
            msg: ''
        }
    }
    else if (isNaN(value)) {
        return {
            status: false,
            msg: 'Completează doar cifre'
        } 
    } else if (value<= 0) {
        return {
            status: false,
            msg: 'Completeaza o sumă pozitivă'
        }
    } else {
        return {
            status: true,
            msg: ''
        }
    }
}


export const SavingAccountTerm = (value) => {
    if (value == '') {
        return {
            status: false,
            msg: 'Completează câmpul'
        }
    } 
    else if (isNaN(value)) {
        return {
            status: false,
            msg: 'Completează doar cifre'
        } 
    } else if (value<= 0) {
        return {
            status: false,
            msg: 'Completeaza o sumă pozitivă'
        }
    } else if (value>36) {
        return {
            status: false,
            msg: 'Perioada maximă pentru o simulare este de 36 luni'
        }
    } else {
        return {
            status: true,
            msg: ''
        }
    }
}

export const CustomerField = (value) => {
    if (value == '') {
        return {
            status: false,
            msg: 'Selectează o opțiune'
        }
    } else if (value =='persoana fizica' || value=='persoana juridica' ) {
        return {
            status: true,
            msg: ''
        }
    } else {
        return {
            status: false,
            msg: 'Valoare incorectă'
        } 
    }
}

export const LeasingAutoCategoryField = (value) => {
    if (value == '') {
        return {
            status: false,
            msg: 'Selectează o opțiune'
        }
    } else if (value =='autoturism' || value=='utilitare'  || value=='comerciale') {
        return {
            status: true,
            msg: ''
        }
    } else {
        return {
            status: false,
            msg: 'Valoare incorectă'
        } 
    }
}

export const LeasingAutoTypeField = (value) => {
    if (value == '') {
        return {
            status: false,
            msg: 'Selectează o opțiune'
        }
    } else if (value =='new car' || value=='used card' ) {
        return {
            status: true,
            msg: ''
        }
    } else {
        return {
            status: false,
            msg: 'Valoare incorectă'
        } 
    }
}

export const DownPaymentField = (value) => {
    if (value == '') {
        return {
            status: false,
            msg: 'Completează câmpul'
        }
    } else if (isNaN(value)) {
        return {
            status: false,
            msg: 'Completează doar cifre'
        } 
    } else if (value < 0) {
        return {
            status: false,
            msg: 'Completeaza o sumă pozitivă'
        }
    } else if (value >= 100) {
        return {
            status: false,
            msg: 'Avansul trebuie să fie sub 100%'
        }
    } else {
        return {
            status: true,
            msg: ''
        }
    }
}

export const LeasingTerm = (value) => {
    if (value == '') {
        return {
            status: false,
            msg: 'Completează câmpul'
        }
    } 
    else if (isNaN(value)) {
        return {
            status: false,
            msg: 'Completează doar cifre'
        } 
    } else if (value<= 0) {
        return {
            status: false,
            msg: 'Completeaza o sumă pozitivă'
        }
    } else if (value>10) {
        return {
            status: false,
            msg: 'Perioada maximă pentru o simulare este de 10 ani'
        }
    } else {
        return {
            status: true,
            msg: ''
        }
    }
}

export const PaydayLoanTerm = (value) => {
    if (value == '' || isNaN(value) || (value<= 0)) {
        return {
            status: false,
            msg: 'Completează corect câmpul'
        }
    } 
    else if (value>45) {
        return {
            status: false,
            msg: 'Perioada maximă pentru o simulare este de 45 zile'
        }
    } else {
        return {
            status: true,
            msg: ''
        }
    }
}